export function publicAppOrigin(): string {
  const env =
    typeof import.meta !== "undefined" &&
    import.meta.env &&
    typeof import.meta.env.VITE_APP_URL === "string"
      ? import.meta.env.VITE_APP_URL.trim()
      : "";
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return "https://app.turbosignco.com";
}

export function inboundWebhookPublicPath(slug: string, token: string): string {
  return `/api/integrations/${slug}/webhook?token=${encodeURIComponent(token)}`;
}

export function inventoryHostWebhookPublicPath(token: string): string {
  return inboundWebhookPublicPath("inventory-host", token);
}

export function ideaRoomWebhookPublicPath(token: string): string {
  return inboundWebhookPublicPath("idearoom", token);
}
